// stages/ContactFormStage.js
import React from 'react';

const ContactFormStage = ({ 
  contactInfo, 
  setContactInfo, 
  submitContactInfo, 
  isSubmitting 
}) => {
  return (
    <div className="stage">
      <h2 className="stage-title">Where Should We Send Your Report?</h2>

      <div className="contact-form-intro">
        <p>We'll email a code to unlock your report, which includes:</p>
        <ul className="benefits-list">
          <li>A complete complexity assessment</li>
          <li>A realistic migration timeline</li>
          <li>A recommended approach</li>
          <li>Practical next steps</li>
        </ul>
      </div>
      
      <div className="contact-form">
        <div className="form-row">
          <div className="form-group">
            <label>Full Name *</label>
            <input
              type="text"
              placeholder="Enter your full name"
              value={contactInfo.name}
              onChange={(e) => setContactInfo(prev => ({ ...prev, name: e.target.value }))}
              className="form-input"
            />
          </div>
          
          <div className="form-group">
            <label>Email Address *</label>
            <input
              type="email"
              placeholder="your.email@company.com"
              value={contactInfo.email}
              onChange={(e) => setContactInfo(prev => ({ ...prev, email: e.target.value }))}
              className="form-input"
            />
          </div>
        </div>
        
        <div className="form-row">
          <div className="form-group">
            <label>Phone Number</label>
            <input
              type="tel"
              placeholder="(555) 123-4567"
              value={contactInfo.phone}
              onChange={(e) => setContactInfo(prev => ({ ...prev, phone: e.target.value }))}
              className="form-input"
            />
          </div>
          
          <div className="form-group">
            <label>Preferred Contact Method</label>
            <select 
              value={contactInfo.preferredContact}
              onChange={(e) => setContactInfo(prev => ({ ...prev, preferredContact: e.target.value }))}
              className="form-input"
            >
              <option value="email">Email</option>
              <option value="phone">Phone</option>
            </select>
          </div>
        </div>
        
        <div className="privacy-notice">
          <p>We won't add you to a mailing list.</p>
        </div>
      </div>
      
      <div className="text-center">
        <button 
          className="btn-primary"
          onClick={submitContactInfo}
          disabled={isSubmitting || !contactInfo.name || !contactInfo.email}
        >
          {isSubmitting ? 'Sending Code...' : 'Send Verification Code'}
        </button>
      </div>
    </div>
  );
};

export default ContactFormStage;